export enum ErrorMessageType {
  Info,
  Success,
  Warning,
  Error,
}
